document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.timeline-section');
  sections.forEach(section => {
    const track = section.querySelector('.timeline-track-main');
    const progressBar = section.querySelector('.timeline-progress-bar');
    const items = section.querySelectorAll('.timeline-item');
    function handleScroll() {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const triggerPoint = windowHeight * 0.6;
      let progress = (triggerPoint - rect.top) / rect.height;
      let percentage = Math.max(0, Math.min(1, progress)) * 100;
      progressBar.style.height = percentage + '%';
      if (percentage >= 100) {
        track.classList.add('is-finished');
      } else {
        track.classList.remove('is-finished');
      }
      items.forEach(item => {
        const hex = item.querySelector('.timeline-hex-marker');
        const hexRect = hex.getBoundingClientRect();
        const trackRect = track.getBoundingClientRect();
        const progressBottom =
          trackRect.top + (percentage / 100) * trackRect.height;
        if (percentage > 0 && progressBottom >= hexRect.top) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
  });
});